import { BagPersonalPlusIcon } from './BagPersonalPlusIcon';

/**
 * author: Matthew Terry
 * id 254FBC4D-1BB7-425B-8FB3-A9BB08106C82
 * name bag-personal-plus
 * version: 7.3.67
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bag-personal-plus.svg
 * tags
 */
export const BackpackPlusIcon = BagPersonalPlusIcon;
export default BackpackPlusIcon